export var valuesGameEndTypeEnum = ["Undefined", "WasAborted", "WasCompleted"];
/*

*/ 
//# sourceMappingURL=GameEndTypeEnum.js.map